const HttpStatusCode = Object.freeze({
    _200ok:{
        code: 200,
        statusText:'ok',
        payload:{}        
    },
    _201created:{
        code:201,
        statusText:'created',
         payload:{}    
    },
    _202accepted:{
        code:202,
        statusText:'accepted',
        payload:{}    
    },
    _203nonAuthInfo:{
        code:203,
        statusText:'non-authoritative information',
        payload:{}    
    },
    _204noContent:{
        code:204,
        statusText:'no content',
        payload:{}
    },
    _301movedPermanently:{
        code:301,
        statusText:'moved permanently',
        payload:{}
    },
    _302found:{
        code:302,
        statusText:'found',
        payload:{}
    },
    _303seeOther:{
        code:303,
        statusText:'see other',
        payload:{}
    },
    _400badRequest:{
        code:400,
        statusText:'bad request',
        payload:{}
    },
    _401unauthorized:{
        code:401,
        statusText:'unauthorized',
        payload:{}
    },
    _402paymentRequired:{
        code:402,
        statusText:'payment required',
        payload:{}
    },
    _403forbidden:{
        code:403,
        statusText:'forbidden',
        payload:{}
    },
    _404notFound:{
        code:404,
        statusText:'not found',
        payload:{}
    },
    _405methodNotAllowed:{
        code:405,
        statusText:'method not allowed',
        payload:{}
    },
    _406notAcceptable:{
        code:406,
        statusText:'method not acceptable',
        payload:{}
    },
    _407proxyAuthRequired:{
        code:407,
        statusText:'proxy authorization required',
        payload:{}
    },

    _408requestTimeout:{
        code:408,
        statusText:'request timeout',
        payload:{}
    },

    _409conflict:{
        code:409,
        statusText:'conflict',
        payload:{}
    },

    _422unprocessableEntity:{
        code:422,
        statusText:'unprocessable Entity',
        payload:{}
    },
    _500InternalServerError :{
        code:500,
        statusText: "Internal Server Error",
        payload : {}
    },
    _501NotImplemented:{
        code:501,
        statusText: "Not Implemented",
        payload: {}
    },
    _502BadGateway: {
        code:502,
        statusText: "Bad Gateway",
        payload: {}
    },
    _503ServiceUnavailable: {
        code: 503,
        statusText: "Service Unavailable",
        payload : {}
    },
    _504GatewayTimeout :{
        code: 504,
        statusText: "Gateway Timeout",
        payload: {}
    }
});

export default HttpStatusCode;